// askSmart-ui/src/pages/TOSP/format.ts

// Money is stored as a plain number and displayed as currency. The "$" is
// prefixed rather than left to Intl's currency style so the symbol stays "$"
// regardless of the viewer's locale, and a negative reads "-$1,250.00".
export function formatCurrency(value: number): string {
  const amount = Math.abs(value).toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  return `${value < 0 ? "-" : ""}$${amount}`;
}

/**
 * The same figure without the sign — for a box that already prints its own
 * "$", where a bare 2197.6 reads as unfinished next to a column of 2,197.60.
 *
 * Only for a value at rest. What's being typed stays exactly as typed, since
 * regrouping digits under the cursor moves it.
 */
export function formatAmount(value: number): string {
  return value.toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

// Lease dates are stored as plain yyyy-mm-dd, and shown the same way.
//
// Deliberately not toLocaleDateString: the date controls next to these are
// native `<input type="date">`, which render yyyy-mm-dd here, and a calculated
// date beside them in the browser's locale format read as a different kind of
// value rather than the same one worked out. Validated rather than passed
// straight through, so a malformed string is visible as itself.
export function formatDate(iso: string): string {
  if (!iso) return "—";
  const [year, month, day] = iso.split("-").map(Number);
  if (!year || !month || !day) return iso;
  const pad = (n: number) => String(n).padStart(2, "0");
  return `${year}-${pad(month)}-${pad(day)}`;
}

/** Areas: thousands-separated, decimals only when the value has them. */
export function formatSqFt(value: number): string {
  return value.toLocaleString(undefined, { maximumFractionDigits: 2 });
}
